import { Injectable } from '@angular/core';
import { Destinatario } from 'src/app/model/notificaresumen';
import { environment } from 'src/environments/environment';
import { imagenes } from '../pdfgenerateEmvs/constantes';
import { DatePipe } from '@angular/common';
import { TokenStorageService } from '../token-storage.service';
import { ClientLoaderService } from 'src/app/core/util/client-loader.service';

@Injectable({
  providedIn: 'root'
})
export class PdfgenerateJustificanteNotificaService {

  constructor(
    private datePipe: DatePipe,
    private tokenStorage: TokenStorageService,
    private clientLoader: ClientLoaderService,
  ) { }

  logo: object = {};
  nombreOrganizacion: String = "";
  urlOrganizacion:String="";
  color: String = "";
  footer: String = "";

  public objetPDF( notificacion ):object{
    this.organizacion()
    let codigoHash = notificacion.hash_documento ? notificacion.hash_documento : notificacion.remesa?.contenido?.codigoHash?.split("_")[0] ?? '';
    return {
      pageMargins: [40, 80, 40, 80],
      header: this.logo,
      content: [ 
        {text:''},
        {
          text: this.nombreOrganizacion,
          style: 'header', alignment: 'center'
        },
        {
          text: 'ACUSE DE RECIBO DE NOTIFICACIÓN - '+(notificacion.aceptar? 'ACEPTADA':'RECHAZADA'),
          style: 'subheader',alignment: 'center'
        },  
        {
          table: {
            headerRows: 1, 
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*', 'auto'],
            body: [
              [{ text: 'DOCUMENTO DE NOTIFICACIÓN', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: this.color, color: 'white' }, {}],
              [{table :{
                body: [
                  [{text:'Código del Expediente:', bold: true, alignment: 'left', border: [false, false, false, false],}, {text: notificacion.identificador, noWrap: true, border: [false, false, false, false], alignment: 'left'}],
                  [{text:'Código del Documento:', bold: true, alignment: 'left', border: [false, false, false, false],}, {text: notificacion.nombre_documento, noWrap: true, border: [false, false, false, false], alignment: 'left'}],
                  [{text:'Asunto:', bold: true, alignment: 'left', border: [false, false, false, false],}, {text: notificacion.descripcion, noWrap: true, border: [false, false, false, false], alignment: 'left'}],
                  [{text:'Código Seguro de Verificación:', bold: true, alignment: 'left', border: [false, false, false, false],}, {text: notificacion.csv, border: [false, false, false, false], alignment: 'left'}]
                ],
              },
              border: [true, false, false, true],
              }, this.buildQrCell()],
            ]
          }
        },
        {
          text: ' ',
        },
        {
          table: {
            
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['auto','*'],
            body: [
              [{ text: 'DOCUMENTOS ADJUNTOS', style: 'tableHeader', colSpan:2, alignment: 'center', fillColor: this.color, color: 'white' },{}],
              [
                {text: 'CÓDIGO:', bold: true,  border: [true, false, false, false],},{text: notificacion.nombre_documento, border: [false, true, true, false],},
              ],
              [
                {text: 'HUELLA DOCUMENTO:', bold: true,  border: [true, false, false, true],},{text:(codigoHash.replace(codigoHash.substring(0,35), '****')), border: [false, false, true, true],},
              ]
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['auto','*'],
            body: [
              [{ text: 'DATOS DEL EMISOR', style: 'tableHeader', colSpan:2, alignment: 'center', fillColor: this.color, color: 'white' },{}],
              [
                { text: 'Entidad:', bold: true,  border: [true, false, false, false],},{text: notificacion.organismo_emisor,border: [false, true, true, false],},
              ],
              [
                {text:'Dirección de la Sede Electrónica: ', bold: true,  border: [true, false, false, true],},{text: this.urlOrganizacion, border: [false, false, true, true],},
              ]
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['auto','*'],
            body: [
              [{ text: 'DATOS DEL FIRMANTE', style: 'tableHeader', colSpan:2, alignment: 'center', fillColor: this.color, color: 'white' },{}],
              [
                { text: 'FIRMANTE: ', bold: true,  border: [true, false, false, true],},{text: this.tokenStorage.getUser().nombre+' '+this.tokenStorage.getUser().apellido1+' '+this.tokenStorage.getUser().numero_documento, border: [false, false, true, true],},
              ],
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['auto','*'],
            body: [
              [{ text: 'DATOS DE LA NOTIFICACIÓN', style: 'tableHeader', colSpan:2, alignment: 'center', fillColor: this.color, color: 'white' },{}],
              [
                { text: 'Código de la Notificación: ', bold: true,  border: [true, false, false, false],},{text: notificacion.identificador,border: [false, false, true, false],},
              ],
              [
                {text:'Asunto: ', bold: true,  border: [true, false, false, false],},{text: notificacion.descripcion,border: [false, false, true, false],},
              ],
              [
                {text:'Fecha Puesta a Disposición: ', bold: true,  border: [true, false, false, false],},{text: notificacion.fecha_disposicion ? this.formatDate(notificacion.fecha_disposicion) : this.formatDate(notificacion.fechaPuestaDisposicion),border: [false, false, true, false],},
              ],
              [
                {text:'Fecha de Rechazo Automático: ', bold: true,  border: [true, false, false, false],},{text: notificacion.fecha_caducidad ? this.formatDate(notificacion.fecha_caducidad) : this.formatDate(notificacion.fechaCaducidad),border: [false, false, true, false],},
              ],
              [
                {text:'Fecha Firma: ', bold: true,  border: [true, false, false, true],},{text: this.date(), border: [false, false, true, true]},
              ]
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*'],
            body: [
              [{ text: 'AVISO LEGAL', style: 'tableHeader',  alignment: 'center', fillColor: this.color, color: 'white' }],
              [
                {text:'Este documento es un acuse de recibo de aceptación o rechazo de la notificación que ha sido puesta a disposición en la Sede Electrónica del emisor y dirigida al destinatario especificado, de conformidad con lo establecido en los artículos 40, 41, 42 y 43 de la ley 39/2015 de Procedimiento Administrativo Común, lo cual le ha sido comunicado en la dirección de correo electrónico y/o dispositivo móvil asociado al destinatario o su representante, si bien la falta de práctica de este aviso no impedirá que la notificación sea considerada plenamente válida.\n\n La notificación puede ser ACEPTADA, RECHAZADA o RECHAZADA AUTOMÁTICAMENTE, en caso de que no haya accedido a su contenido antes la fecha marcada en Rechazo Automático, en el área privada de la Sede Electrónica, previa identificación fehaciente con un certificado digital reconocido o mecanismo alternativo y con los efectos legales que procedan en cada caso, en función del procedimiento administrativo y el acto que se notifique.\n\n', 
                alignment: 'justify', style: 'legalText'},
              ]
            ]
          },
        },
      ],
      footer: {
        table: {
          widths: ['*'],
          body: [
            [{text: this.footer, border: [false, true, false, false], borderColor: ['#fff', 'gray', '#fff', '#fff'], color: 'gray',  alignment: 'center', fontSize: 9, }]
          ]
        }
      },
      styles: {
        tableHeader: {
          fontSize: 12,
        },
        header: {
          fontSize: 18,
          bold: true
        },
        subheader: {
          fontSize: 14,
          bold: true
        },
        legalText: {
          fontSize: 8,
        },
      }
    }
  }


  /** pdfmake no admite qr vacío → "Unrecognized document structure" */
  private buildQrCell(): object {
    const url = (this.urlOrganizacion || '').toString().trim();
    if (!url) {
      return { text: '', border: [false, false, true, true] };
    }
    return {
      qr: url,
      eccLevel: 'H',
      fit: 80,
      border: [false, false, true, true],
    };
  }

  private organizacion(): void {
    const clientFolder = this.clientLoader.getImageFolder();
    const isEmvs = clientFolder === 'emvs' || environment.environment === 'emvs';

    if (isEmvs) {
      this.logo = { image: imagenes.headerEmvs, width: 500, margin: [20, 0, 40, 0] };
      this.nombreOrganizacion = this.clientLoader.getConfigSync(
        'title-head',
        environment.TITLE_HEAD ?? 'Oficina virtual - Empresa Municipal de la Vivienda y Suelo'
      );
      this.color = this.clientLoader.getConfigSync('pdf_primary_color', '#699EC5');
      this.footer = this.clientLoader.getConfigSync(
        'pdf_footer_legal_text',
        'Palos de la Frontera, 13. Madrid, 28012 - Telef. 915 16 81 50 www.oficinavirtual.emvs.es CIF: A-28740314'
      );
      this.urlOrganizacion = this.clientLoader.getConfigSync(
        'pdf_csv_verification_url',
        'https://oficinavirtual.emvs.es/#/'
      );
      return;
    }

    // GMU (u otros clientes): mismos campos desde tema/API; sin logo EMVS embebido
    this.logo = { text: ' ', margin: [20, 0, 40, 0] };
    this.nombreOrganizacion = this.clientLoader.getConfigSync(
      'title-head',
      'Oficina Virtual - GMU'
    );
    this.color = this.clientLoader.getConfigSync('pdf_primary_color', '#508b84');
    this.footer = this.clientLoader.getConfigSync(
      'pdf_footer_legal_text',
      'Gerencia Municipal de Urbanismo - Ayuntamiento de Córdoba'
    );
    this.urlOrganizacion = this.clientLoader.getConfigSync(
      'pdf_csv_verification_url',
      this.clientLoader.getConfigSync('footer_web_url', 'https://www.gmucordoba.es/#/')
    );
  }

  formatDate(date) {
    
    let month = date && date[1] ? (date[1]<10)?'0'+date[1]:date[1] : '';
    let day   = date && date[2] ? (date[2]<10)?'0'+date[2]:date[2] : '';
    let year  = date && date[0] ? date[0] : '';
    let hour  = date && date[3] ? (date[3]<10)?'0'+date[3]:date[3]: '';
    let min   = date && date[4] ? (date[4]<10)? '0'+date[4]:date[4]: '';
    let seg   = date && date[5] ? date[5] ? (date[5]<10)?'0'+date[5]:date[5] : '00' : '';
    
    return [ year, month, day].join('-').concat('T'+[hour, min, seg].join(':') + '.000Z');
  }


  private date(): String{
    return this.datePipe.transform(Date.now(), 'dd/MM/yyyy HH:mm:ss');
  }

}

